<div class="license-card-container container default-padding mat-elevation-z1" fxLayout="column" fxLayoutGap="15px">
  <h2 class="mat-h2 color-primary text-small-caps no-bottom-margin">{{ 'licenseCard.title' | translate }}</h2>
  <hr/>
  <div fxLayout="column">
    <mtn-key-value [key]="'licenseCard.type' | translate">
      <span>{{licenseType?.displayName}}</span>
    </mtn-key-value>
    <mtn-key-value [key]="'licenseCard.expirationDate' | translate">
      <span
        *ngIf="company.license.expirationDate; else nonExpiring">{{company.license.expirationDate | insightsDate}}</span>
      <ng-template #nonExpiring>
        <span class="color-muted">{{ 'licenseCard.nonExpiring' | translate }}</span>
      </ng-template>
    </mtn-key-value>
    <mtn-key-value [key]="'licenseCard.status' | translate">
      <span class="color-success" *ngIf="company.license.isValid()">{{ 'licenseCard.statusActive' | translate }}</span>
      <span class="color-error" *ngIf="!company.license.suspendedDate && company.license.isExpired()">
        {{ 'licenseCard.statusExpired' | translate }}
      </span>
      <span class="color-error" *ngIf="company.license.suspendedDate">
        {{ 'licenseCard.statusSuspended' | translate }}
      </span>
    </mtn-key-value>
    <mtn-key-value [key]="'licenseCard.reason' | translate"
                   *ngIf="isActionsEnabled && company.license.suspendedDate"
                   [ngSwitch]="company.license.suspendedReason">
      <span class="color-error" *ngSwitchCase="'ABUSE'">{{ 'licenseCard.reasonAbuse' | translate }}</span>
      <span class="color-error" *ngSwitchCase="'NON_PAYMENT'">{{ 'licenseCard.reasonNonPayment' | translate }}</span>
      <span class="color-error" *ngSwitchCase="'OTHER'">{{ 'licenseCard.reasonOther' | translate }}</span>
    </mtn-key-value>
  </div>
  <div fxLayout="row" fxLayoutGap="15px" *ngIf="isActionsEnabled">
    <button mat-raised-button class="default-button" [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
      {{ 'licenseCard.updateLicense' | translate }}
    </button>
    <button mat-raised-button color="warn" [disabled]="true" matTooltip="Feature disabled for Insights entitlements"
            *ngIf="!company.license.suspendedDate; else reinstate">
      {{ 'licenseCard.suspendLicense' | translate }}
    </button>
    <ng-template #reinstate>
      <button mat-raised-button class="success-button" [disabled]="true" matTooltip="Feature disabled for Insights entitlements">
        {{ 'licenseCard.reinstateLicense' | translate }}
      </button>
    </ng-template>
  </div>
</div>
